<div class="modal-header">
    <span class="pull-right">
        <button class="btn btn-default btn-xs" (click)="close()"><i class="glyphicon glyphicon-remove"></i></button>
    </span>
    <span>
        <h4 class="modal-title">{{ title }}</h4>
    </span>  
</div>
  
<div class="modal-body">
    <p>{{ body }}</p>
</div>

<div class="modal-footer">
    <div class="text-right">
        <button type="button" class="btn btn-success" (click)="confirm()">
            Yes
        </button>
        <button type="button" class="btn btn-default" (click)="cancel()">
            No
        </button>
    </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/confirmation-modal/confirmation-modal.component.html